/* eslint-disable */
var break_point = 1088;
var navname = "main-menu";

//hamburgers
  $('.hamburger').click(function() {
    $(this).toggleClass('is-active');
  });

function add_item_span() {
  //console.log("add_item_span");
  $(".mobilemenu-container li.menu-item-has-children").each(function() {
    $(this).append('<span class="extract"></span>');
  });
}

function expand() {
  //console.log("expand");
  $(".mobilemenu-container li.menu-item-has-children span.extract").on(
    "click",
    function() {

      var parentid = $(this).closest('li');
      parentid.toggleClass('expanded');
      //console.log($(this).closest('li').attr('class'));
      parentid.find('.sub-menu').slideToggle( "fast", function() {
        // Animation complete.
      });

    }
  );
}

function mobile_open_close() {
  //console.log("mobile_open_close");
  $("button.hamburger").on("click", function(e) {
    // $('.mobilemenu-container').removeClass("piilota");
    // $('.mobilemenu-wrap-overlay').removeClass("piilota");

    if ($(this).hasClass("is-active")) {
      $(".mobilemenu-container").toggleClass("piilota");
      $(".mobilemenu-wrap-overlay").toggleClass("piilota");
    } else {
      $(".mobilemenu-container").toggleClass("piilota");
      $(".mobilemenu-wrap-overlay").toggleClass("piilota");
    }

    e.stopPropagation();
  });

}

//hide mobile menu on click of anything else
$(document).on('click', function (e) {
  if(!$(".mobilemenu-container").hasClass("piilota")){
    $(".mobilemenu-container").toggleClass("piilota");
    $(".mobilemenu-wrap-overlay").toggleClass("piilota");
    $(".hamburger").toggleClass('is-active');
  }
});

add_item_span();
expand();
mobile_open_close();




/* eslint-enable */


// WEBPACK FOOTER //
// ./scripts/autoload/menus.js